/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DeliveryDto
 */
export interface DeliveryDto {
    /**
     * Delivery ID
     * @type {string}
     * @memberof DeliveryDto
     */
    'id': string;
    /**
     * Participation ID this delivery belongs to
     * @type {string}
     * @memberof DeliveryDto
     */
    'participationId': string;
    /**
     * Delivery recipient name
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationName': string;
    /**
     * Delivery contact number
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationContactNumber': string;
    /**
     * Destination country
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationCountry': string;
    /**
     * Destination country code
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationCountryCode': string;
    /**
     * Destination province
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationProvince': string;
    /**
     * Destination province code
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationProvinceCode': string;
    /**
     * Destination city
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationCity': string;
    /**
     * Destination city code
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationCityCode': string;
    /**
     * Destination barangay
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationBarangay': string;
    /**
     * Destination barangay code
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationBarangayCode': string;
    /**
     * Destination street address
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationStreet': string;
    /**
     * Destination postal code
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationPostalCode': string;
    /**
     * Source API used for address data
     * @type {string}
     * @memberof DeliveryDto
     */
    'destinationSourceApi': DeliveryDtoDestinationSourceApiEnum;
    /**
     * Origin sender/company name
     * @type {string}
     * @memberof DeliveryDto
     */
    'originName'?: string;
    /**
     * Origin contact number
     * @type {string}
     * @memberof DeliveryDto
     */
    'originContactNumber'?: string;
    /**
     * Origin country
     * @type {string}
     * @memberof DeliveryDto
     */
    'originCountry'?: string;
    /**
     * Origin country code
     * @type {string}
     * @memberof DeliveryDto
     */
    'originCountryCode'?: string;
    /**
     * Origin province
     * @type {string}
     * @memberof DeliveryDto
     */
    'originProvince'?: string;
    /**
     * Origin province code
     * @type {string}
     * @memberof DeliveryDto
     */
    'originProvinceCode'?: string;
    /**
     * Origin city
     * @type {string}
     * @memberof DeliveryDto
     */
    'originCity'?: string;
    /**
     * Origin city code
     * @type {string}
     * @memberof DeliveryDto
     */
    'originCityCode'?: string;
    /**
     * Origin barangay
     * @type {string}
     * @memberof DeliveryDto
     */
    'originBarangay'?: string;
    /**
     * Origin barangay code
     * @type {string}
     * @memberof DeliveryDto
     */
    'originBarangayCode'?: string;
    /**
     * Origin street address
     * @type {string}
     * @memberof DeliveryDto
     */
    'originStreet'?: string;
    /**
     * Origin postal code
     * @type {string}
     * @memberof DeliveryDto
     */
    'originPostalCode'?: string;
    /**
     * Source API used for origin address data
     * @type {string}
     * @memberof DeliveryDto
     */
    'originSourceApi'?: DeliveryDtoOriginSourceApiEnum;
    /**
     * Current delivery status
     * @type {string}
     * @memberof DeliveryDto
     */
    'status': DeliveryDtoStatusEnum;
    /**
     * Tracking number provided by courier
     * @type {string}
     * @memberof DeliveryDto
     */
    'trackingNo'?: string;
    /**
     * Tracking link URL
     * @type {string}
     * @memberof DeliveryDto
     */
    'trackingLink'?: string;
    /**
     * Delivery courier/service name
     * @type {string}
     * @memberof DeliveryDto
     */
    'deliveryCourier'?: string;
    /**
     * Timestamp when delivery was set to on standby
     * @type {string}
     * @memberof DeliveryDto
     */
    'onStandbyAt'?: string;
    /**
     * Timestamp when delivery status changed to shipping soon
     * @type {string}
     * @memberof DeliveryDto
     */
    'shippingSoonAt'?: string;
    /**
     * Timestamp when delivery went in transit
     * @type {string}
     * @memberof DeliveryDto
     */
    'inTransitAt'?: string;
    /**
     * Timestamp when delivery went out for delivery
     * @type {string}
     * @memberof DeliveryDto
     */
    'outForDeliveryAt'?: string;
    /**
     * Timestamp when delivery was completed
     * @type {string}
     * @memberof DeliveryDto
     */
    'deliveredAt'?: string;
    /**
     * Timestamp when delivery was cancelled
     * @type {string}
     * @memberof DeliveryDto
     */
    'cancelledAt'?: string;
    /**
     * Array of image URLs for delivery proof
     * @type {Array<string>}
     * @memberof DeliveryDto
     */
    'imageUrls': Array<string>;
    /**
     * Whether the delivery has been confirmed by the user
     * @type {boolean}
     * @memberof DeliveryDto
     */
    'isConfirmedByUser': boolean;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof DeliveryDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof DeliveryDto
     */
    'updatedAt': string;
}

export const DeliveryDtoDestinationSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type DeliveryDtoDestinationSourceApiEnum = typeof DeliveryDtoDestinationSourceApiEnum[keyof typeof DeliveryDtoDestinationSourceApiEnum];
export const DeliveryDtoOriginSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type DeliveryDtoOriginSourceApiEnum = typeof DeliveryDtoOriginSourceApiEnum[keyof typeof DeliveryDtoOriginSourceApiEnum];
export const DeliveryDtoStatusEnum = {
    OnStandby: 'on_standby',
    ShippingSoon: 'shipping_soon',
    InTransit: 'in_transit',
    OutForDelivery: 'out_for_delivery',
    Delivered: 'delivered',
    Cancelled: 'cancelled'
} as const;

export type DeliveryDtoStatusEnum = typeof DeliveryDtoStatusEnum[keyof typeof DeliveryDtoStatusEnum];


